import * as styles from './styles.css';
import * as React from 'react';
import { PROMO_ICON } from '../constants/icons';

export function BonusIcon() {
  return (
    <div className={styles['container']}>
      <img src={PROMO_ICON.get('bonus')} className={styles['icon-img']} />
    </div>
  );
}
